/* ============================================================
   aplus-faq.js — A+ 产品页 FAQ 手风琴交互
   2026-10-19 · 修复：lotteds-<系列>-faq 点击无反应
   原因：部署 A+ 模板时只上了 HTML + CSS，缺切换 .open 的 JS
   覆盖：所有系列（spirava/snake/rollers/aeris/aura/quatrefoil…）
   结构：.{prefix}-faq-item > .{prefix}-faq-q + .{prefix}-faq-a
   展开态：CSS 已定义 .{prefix}-faq-item.open .{prefix}-faq-a{display:block}
   ============================================================ */
(function () {
  'use strict';

  var Q_SELECTOR = 'div[class*="lotteds-"][class*="-faq-q"]';

  function toggle(question) {
    var item = question.parentElement;
    if (!item || !/-faq-item/.test(item.className)) return;
    var isOpen = item.classList.toggle('open');
    question.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  }

  // 事件委托：兼容 section 重新渲染（主题编辑器 / 动态区块）
  document.addEventListener('click', function (e) {
    var q = e.target.closest(Q_SELECTOR);
    if (q) toggle(q);
  });

  // 键盘可达性：Enter / Space
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var q = e.target.closest && e.target.closest(Q_SELECTOR);
    if (!q) return;
    e.preventDefault();
    toggle(q);
  });

  // 初始化可访问性属性
  function init() {
    var qs = document.querySelectorAll(Q_SELECTOR);
    for (var i = 0; i < qs.length; i++) {
      var q = qs[i];
      if (q.getAttribute('data-faq-ready') === '1') continue;
      q.setAttribute('data-faq-ready', '1');
      q.setAttribute('role', 'button');
      q.setAttribute('tabindex', '0');
      q.setAttribute('aria-expanded', 'false');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
